// extracted by mini-css-extract-plugin
export default {"InputWrapper":"EnterMfaCodeFieldset_InputWrapper__8pAKi","Input":"EnterMfaCodeFieldset_Input__b3yoD"};